const ctabtnwrapper = document.querySelector('.product_details .product-form__submit');
const stickAddToCartBtn =  document.querySelector('[js-pdp-stick-addToCart-btn]');
const stickAddToCartBtnStitched =  document.querySelector('[js-pdp-stick-addtocart-btn-stitched]');
const productForm = document.querySelector("product-form");
const variantSelects = document.querySelector("variant-selects");
const announcementBar = document.querySelector(".Header_announcement_bar_main_new");
const Header = document.querySelector(".header-wrapper");
const stickBuyNowBtn =  document.querySelector('[data-buy-now]');
const stickBuyNowBtnDone =  document.querySelector('[data-buy-now-done]');

  function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

if(ctabtnwrapper) {
    window.addEventListener('scroll', e => {
        if(window.scrollY > offset(ctabtnwrapper).top) {
            document.body.classList.add('scrolled-past-header-body');
            document.querySelector('[js-pdp-sticky-addtocart-wrapper]').style.bottom = 0;
        } else {
            document.body.classList.remove('scrolled-past-header-body');
            document.querySelector('[js-pdp-sticky-addtocart-wrapper]').style.bottom = "-100%";
        }
    });
    if (window.innerWidth > 767) {
      stickAddToCartBtn.addEventListener('click', () => {
          ctabtnwrapper.click();
          setTimeout(() => // this changes the scrolling behavior to "smooth"
          {
              const headerGroupHeight = ((announcementBar?.clientHeight || 0) + Header.clientHeight);
              const scrollVal = (window.scrollY + variantSelects.getBoundingClientRect().top) - headerGroupHeight;
              console.log('scrollVal', scrollVal)
              window.scrollTo({ top: scrollVal, behavior: 'smooth' })
          }
          , 500)
      })
    }
  function stickyContentChange(currentVarient) {
      const container_ = document.querySelector('[js-product-details]')
      if(currentVarient) {
        if(document.querySelector('[js-pdp-sticky-addToCart-option-label]')){
          document.querySelector('[js-pdp-sticky-addToCart-option-label]').textContent = currentVarient.title;
        }
        const currencySymbol = container_.querySelector('[data-shop-currency]').dataset.shopCurrency
        if(currentVarient.compare_at_price > 0) {
          if(document.querySelector('[js-pdp-sticky-compare-at-price]')) {
            document.querySelector('[js-pdp-sticky-compare-at-price]').textContent = currencySymbol + (currentVarient.compare_at_price / 100) + ' ' + Shopify.currency.active
          }
        }
        document.querySelectorAll('[js-pdp-original-price]').forEach(originalPrice => {
            originalPrice.textContent = currencySymbol + Math.round((currentVarient.price / 100)) + ' ' + Shopify.currency.active
        })
        if (typeof window.applyVariantDiscountLabel === 'function') {
          window.applyVariantDiscountLabel(currentVarient);
        } else {
          document.querySelectorAll('.discount_percentage').forEach(discountEl => {
            discountEl.textContent = window.getVariantDiscountLabel
              ? window.getVariantDiscountLabel(currentVarient, { offCasing: 'Off' })
              : '';
          });
        }
      }
    }
    
    document.addEventListener('sticky-cta-content:init', (e) => {
        stickyContentChange(e.detail)
    });
}


// sticky add to cart with variable popup
var popupTriggre = false
var checkVisibilityButton = false
function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}


function handleIntersection(entries, observer) {
  entries.forEach(function(entry) {
    if (!entry.isIntersecting) {
      popupTriggre = true
    } else {
      popupTriggre = false
    }
  });
}
var observer = new IntersectionObserver(handleIntersection, {
  root: null, 
  threshold: 1
});
observer.observe(productForm);

function checkVisibility() {
  if (productForm && isElementInViewport(productForm)) {
    checkVisibilityButton = true;
  } else {
    checkVisibilityButton = false;
  }
}

const sizeInput = document.querySelectorAll('.o-Size .product-form__input_wrap');
function sizeFirstLineAddClass() {
  const firstChipTop = sizeInput[0].getBoundingClientRect().top;
  const firstRowChips = Array.from(sizeInput).filter(sizeInput => {
    return sizeInput.getBoundingClientRect().top === firstChipTop;
  });
  firstRowChips.forEach(sizeInput => {
    sizeInput.classList.add('size-first-row');
  });
}
function sizeFirstLineRemoveClass() {
  sizeInput.forEach(input => {
    input.classList.remove('size-first-row');
  });
}

let mobileStickyInitialized = false;
function mobileStickyVar() {
   if (window.innerWidth > 767 || mobileStickyInitialized) return;
   mobileStickyInitialized = true;
    const closePopup = document.querySelector("#closeSizePopup");
    const deliveryWrapper = document.querySelector(".delivery-wrapper-with-express");
    const standerdDeliveryWrapper = document.querySelector(".cs_delivery_wrapper[js-delivery-wrapper]");
    if (deliveryWrapper) productForm.querySelector('form').appendChild(deliveryWrapper);
    if (standerdDeliveryWrapper) productForm.querySelector('form').appendChild(standerdDeliveryWrapper);
    checkVisibility();
     
    function openVariablePopup() {
      productForm.classList.add('sticky-variable');
      document.querySelector('body').classList.add('variable-popup-open');
      sizeFirstLineAddClass();
    }
   function openVariablePopupBuyNow() {
     document.querySelector('body').classList.add('sticky-variable-buy-open');
   }
   function closeVariablePopupBuyNow() {
     document.querySelector('body').classList.remove('sticky-variable-buy-open');
   }
    function closeVariablePopup() {
      productForm.classList.remove('sticky-variable'); 
      document.querySelector('body').classList.remove('variable-popup-open');
      sizeFirstLineRemoveClass();
    }
    function submitMainForm() {
      if (!ctabtnwrapper || ctabtnwrapper.getAttribute('aria-disabled') === 'true') return;
      ctabtnwrapper.click();
    }
    let isBuyNowSubmitting = false;
    function BuyNowBtn() {
      if (isBuyNowSubmitting) return;
      const twiningProduct = productForm.querySelector('.twining-tab-warp');
      if (twiningProduct) {
        const form = document.querySelector('form[action$="/cart/add"]');
        if (!form) return;
        const refTimeStamp = Date.now();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        // Female
        const product1Input = form.querySelector('input[name="Size-Product1"]:checked');
        const product2Input = form.querySelector('input[name="Size-Product2"]:checked');
        
        const femaleTab = form.querySelector('.twining-tab ul li:first-child');
        const maleTab = form.querySelector('.twining-tab ul li:nth-child(2)');
        const requiredFields = form.querySelectorAll("[data-original-required='true']");
        for (const el of requiredFields) {
          if (el.value.trim() === "") {
            femaleTab.click();
            return;
          }
        }
        if (!product1Input) { 
          femaleTab.click();
          return;
        }
        if (!product2Input) { 
          maleTab.click();
          return;
        }
        
        
        const femaleProps = getItemProperties(form, 0);
        

        // Male
        
        const femaleVariantId = Number(
          product1Input.getAttribute("varid") ||
          form.querySelector(`label[for="${product1Input.id}"]`)?.getAttribute("varid")
        );
        const maleVariantId = Number(
          product2Input.getAttribute("varid") ||
          form.querySelector(`label[for="${product2Input.id}"]`)?.getAttribute("varid")
        );
        
        const upsellProducts = form.querySelectorAll('[js-upsell-product] input:checked');

        /* -------------------------------------------------
            🔥 STEP 1 — BUILD TWINNING ITEMS FOR BUY NOW
        -------------------------------------------------- */

        function getItemProperties(form, itemIndex) {
          const props = {};

          const selector = `
            input[name^="items[${itemIndex}][properties"]:not(.blouse-style-input),
            input[name^="items[${itemIndex}][properties"].blouse-style-input:checked,
            select[name^="items[${itemIndex}][properties"]
          `;

          form.querySelectorAll(selector).forEach(input => {
            if (input.disabled) return;
            const match = input.name.match(new RegExp(`items\\[${itemIndex}\\]\\[properties\\]\\[(.+?)\\]`));
            if (!match) return;
            props[match[1]] = input.value;
          });

          return props;
        }

        

        const maleProps = getItemProperties(form, 1);

        // FINAL twin items
        const twinningItems = [
          { id: femaleVariantId, quantity: 1, properties: femaleProps },
          { id: maleVariantId, quantity: 1, properties: maleProps }
        ];

        // 🎉 NOW twinningItems is ALWAYS READY
        console.log("Buy Now → Twinning Items", twinningItems);

        /* -------------------------------------------------
            🔥 STEP 2 — CALL GLOBAL myGlobalFunction
        -------------------------------------------------- */
        if (typeof window.myGlobalFunction === "function") {
          window.myGlobalFunction("Buy Now", twinningItems)
            .then(() => { window.location.href = '/checkout'; })
            .catch((err) => alert(err && err.message ? err.message : 'Error adding products.'));
        } else {
          console.warn("myGlobalFunction not found");
        }

      } else {
        const addToCartForm = document.querySelector('form[action$="/cart/add"]');
        if (!addToCartForm) return;
      
        if (addToCartForm.checkValidity()) {
          const refTimeStamp = Date.now();
          const upsellProducts = addToCartForm.querySelectorAll('[js-upsell-product] input:checked');
          const validUpsells = Array.from(upsellProducts).filter((elm) => !!(elm.dataset.productId || elm.value));
      
          const mainFormData = new FormData(addToCartForm);

          addToCartForm.querySelectorAll('[js-upsell-product] input[type="checkbox"]').forEach((elm) => {
            if (elm.name) mainFormData.delete(elm.name);
          });

          const mainId = mainFormData.get('items[0][id]') || mainFormData.get('id');
          const mainQty = mainFormData.get('items[0][quantity]') || mainFormData.get('quantity') || 1;

          const extractPropertyName = (key) => {
            const match = key.match(/^(?:items\[0\])?\[?properties(?:\]?\[|\[)([^\]]+)\]+$/);
            return match ? match[1] : null;
          };

          const mainProperties = new Map();
          const allEntries = Array.from(mainFormData.entries());
          allEntries.forEach(([key, val]) => {
            const propName = extractPropertyName(key);
            if (propName) {
              if (!['_ref_id', '_with_upsell', '_type'].includes(propName)) {
                mainProperties.set(propName, val);
              }
              mainFormData.delete(key);
            }
          });

          const domDeliveryChecks = [
            { sel: '[js-estimated-standard-delivery-input]', prop: 'Estimated standard delivery' },
            { sel: '[js-estimated-delivery-input]', prop: 'Estimated delivery' },
            { sel: '[js-estimated-express-delivery-input]', prop: 'Priority express shipping' },
            { sel: '[js-estimated-delivery-days-input]', prop: '_Delivery days' }
          ];
          domDeliveryChecks.forEach(({ sel, prop }) => {
            if (!mainProperties.has(prop)) {
              const el = addToCartForm.querySelector(sel) || document.querySelector(sel);
              if (el && el.value) {
                mainProperties.set(prop, el.value);
              }
            }
          });

          mainFormData.delete('id');
          mainFormData.delete('quantity');
          mainFormData.delete('items[0][id]');
          mainFormData.delete('items[0][quantity]');
          mainFormData.delete('properties[_ref_id]');
          mainFormData.delete('properties[_with_upsell]');
          mainFormData.delete('properties[_type]');

          if (validUpsells.length > 0) {
            const reversedUpsells = [...validUpsells].reverse();
            reversedUpsells.forEach((elm, index) => {
              const id = elm.dataset.productId || elm.value;
              mainFormData.set(`items[${index}][id]`, Number(id));
              mainFormData.set(`items[${index}][quantity]`, 1);
              mainFormData.set(`items[${index}][properties][_ref_id]`, refTimeStamp);
              mainFormData.set(`items[${index}][properties][_type]`, 'sub product');
            });

            const mainIndex = reversedUpsells.length;
            mainFormData.set(`items[${mainIndex}][id]`, Number(mainId));
            mainFormData.set(`items[${mainIndex}][quantity]`, Number(mainQty));

            mainProperties.forEach((val, propName) => {
              mainFormData.set(`items[${mainIndex}][properties][${propName}]`, val);
            });

            mainFormData.set(`items[${mainIndex}][properties][_ref_id]`, refTimeStamp);
            mainFormData.set(`items[${mainIndex}][properties][_with_upsell]`, 'Yes');
            mainFormData.set(`items[${mainIndex}][properties][_type]`, 'main product');
          } else {
            mainFormData.set('items[0][id]', Number(mainId));
            mainFormData.set('items[0][quantity]', Number(mainQty));

            mainProperties.forEach((val, propName) => {
              mainFormData.set(`items[0][properties][${propName}]`, val);
            });

            mainFormData.set('items[0][properties][_type]', 'main product');
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: mainFormData
          })
            .then((res) => res.json())
            .then(async (data) => {
              if (data && data.status && data.description) {
                alert(data.description);
                isBuyNowSubmitting = false;
                return;
              }

              // Ensure auto-addon gift product is synced before redirecting to checkout
              if (typeof window.kalkiSyncAutoAddon === 'function') {
                try {
                  await window.kalkiSyncAutoAddon({ fromAdd: true });
                } catch (err) {
                  console.error('Error syncing auto addon on Buy Now:', err);
                }
              }

              window.location.href = '/checkout';
            })
            .catch((e) => {
              console.error('❌ Error adding products:', e);
              isBuyNowSubmitting = false;
            });
        } else {
          isBuyNowSubmitting = false;
          addToCartForm.reportValidity();
        }
      }
    }
     
     
    var inputChecked = false
    function checkInputs() {
        const radioButtons = productForm.querySelectorAll('input[type="radio"]');
        const isRadioSelected = Array.from(radioButtons).some(radio => radio.checked);
        const selectBoxes = productForm.querySelectorAll('select');
        const areSelectsSelected = Array.from(selectBoxes).every(select => select.value !== '');
        if (radioButtons.length > 0 || selectBoxes.length > 0) {
          if (!isRadioSelected || !areSelectsSelected) {
              inputChecked = true
          } else {
            inputChecked = false
          }
        }
    }
    
    if(ctabtnwrapper) {
      productForm.addEventListener('change', checkInputs);
      if (stickAddToCartBtnStitched) {
        stickAddToCartBtnStitched.addEventListener('click', () => {
          if (!popupTriggre && !checkVisibilityButton) {
            submitMainForm();
            return;
          }
          checkInputs();
          openVariablePopup();
        });
      }

      if (stickBuyNowBtnDone) {
        stickBuyNowBtnDone.addEventListener('click', (e) => {
          e.preventDefault();
          BuyNowBtn();
        });
      }

      stickBuyNowBtn && stickBuyNowBtn.addEventListener('click', (e) => {
        if (productForm.querySelector("variant-selects")) {
          e.preventDefault();
          if (!popupTriggre && !checkVisibilityButton) {
            BuyNowBtn();
            return;
          }
          checkInputs();
          const Stitched = document.querySelector('.options-header.Stitched');
          const Mod = document.querySelector('.options-header[class*="Conf Size Options"]');
          const popupAlreadyOpen = productForm.classList.contains('sticky-variable');

          if (!popupAlreadyOpen && (Stitched || Mod || inputChecked || ctabtnwrapper.classList.contains('unavailable-variant'))) {
            openVariablePopup();
            openVariablePopupBuyNow();
            return;
          }

          BuyNowBtn();

          if (productForm.classList.contains('sticky-variable')) {
            var errorDiv = document.querySelector('.product-form__error-message-wrapper');
            var checkVisibility = setInterval(function() {
              if (!errorDiv.hasAttribute('hidden')) {
                  errorDiv.scrollIntoView({ behavior: 'smooth' });
                  clearInterval(checkVisibility);
              }
            }, 500);
          } else {
            setTimeout(() => {
                const headerGroupHeight = ((announcementBar?.clientHeight || 0) + Header.clientHeight);
                const scrollVal = (window.scrollY + variantSelects.getBoundingClientRect().top) - headerGroupHeight;
                window.scrollTo({ top: scrollVal, behavior: 'smooth' });
            }, 500);
          }
        } else {
          BuyNowBtn();
        }
      });
      
      stickAddToCartBtn.addEventListener('click', () => {
        if (!popupTriggre && !checkVisibilityButton) {
          submitMainForm();
          return;
        }
        checkInputs();
        const Stitched = document.querySelector('.options-header.Stitched')
        const Mod = document.querySelector('.options-header[class*="Conf Size Options"]')
        const popupAlreadyOpen = productForm.classList.contains('sticky-variable');
        if (!popupAlreadyOpen && (Stitched || Mod || inputChecked || ctabtnwrapper.classList.contains('unavailable-variant'))) {
          openVariablePopup();
          return;
        }
        submitMainForm();
        if (productForm.classList.contains('sticky-variable')) {
          var errorDiv = document.querySelector('.product-form__error-message-wrapper');
          var checkVisibility = setInterval(function() {
            if (!errorDiv.hasAttribute('hidden')) {
                errorDiv.scrollIntoView({ behavior: 'smooth' });
                clearInterval(checkVisibility);
            }
          }, 500);
        } else {
          setTimeout(() => {
              const headerGroupHeight = ((announcementBar?.clientHeight || 0) + Header.clientHeight);
              const scrollVal = (window.scrollY + variantSelects.getBoundingClientRect().top) - headerGroupHeight;
              window.scrollTo({ top: scrollVal, behavior: 'smooth' })
          }, 500)
        }
      });
      closePopup.addEventListener('click', () => {
        closeVariablePopup();
        closeVariablePopupBuyNow()
        const varUnstitched = document.querySelector('.product-form__input input[type=radio][value="Unstitched"] + label')
        if (varUnstitched) {
          const x = window.scrollX;
          const y = window.scrollY;
          varUnstitched.click();
          window.scrollTo(x, y);
        }
      });
    }
}
mobileStickyVar();
window.addEventListener("resize", mobileStickyVar);


var observerCartDrawer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      var cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer.classList.contains('active')) {
        productForm.classList.remove('sticky-variable'); 
        document.querySelector('body').classList.remove('variable-popup-open');
        sizeFirstLineRemoveClass()
      }
    }
  });
});

observerCartDrawer.observe(document.querySelector('cart-drawer'), {
  attributes: true 
});